export enum LineOfProduct {
	BUY_REFURBISHED = 'Buy Refurbished',
	BUY_NEW = 'Buy Brand New',
	RENT = 'Rent',
	All = 'All',
	UNLMTD = 'UNLMTD'
}
